import { Route, Routes } from 'react-router-dom';
import { ModifyOfferPage } from './ModifyOfferPage';
import { OffersPage } from './OffersPage';

export const OfferPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyOfferPage />} />
    <Route path='/:offerID' element={<ModifyOfferPage />} />
    <Route path='*' element={<OffersPage />} />
  </Routes>
);
